import {
  HttpDataState,
  InspectionDataState,
  ReportsData,
  StateChangesState,
  TabDataState,
} from 'store/analytics/data/analyticsDataTypes';
import { TxiViewRequest } from 'types/rest/analyticsTypes';

export const UPDATE_DATA_CONTEXT = 'UPDATE_DATA_CONTEXT';
export const UPDATE_TAB_DATA = 'UPDATE_TAB_DATA';
export const INITIALISE_TAB_DATA = 'INITIALISE_TAB_DATA';
export const ADD_TAB_DATA = 'ADD_TAB_DATA';
export const INSPECTION_VIEW_UPDATE = 'INSPECTION_VIEW_UPDATE';
export const INSPECTION_VIEW_SET_IS_LOADING_REQUESTS = 'INSPECTION_VIEW_SET_IS_LOADING_REQUESTS';
export const INSPECTION_VIEW_SET_REQUESTS_LOADED_TS = 'INSPECTION_VIEW_SET_REQUESTS_LOADED_TS';
export const INSPECTION_VIEW_SET_IS_LOADING_DETAIL = 'INSPECTION_VIEW_SET_IS_LOADING_DETAIL';
export const INSPECTION_VIEW_SET_IS_REQUEST_SENT = 'INSPECTION_VIEW_SET_IS_REQUEST_SENT';
export const INSPECTION_VIEW_UPDATE_REQUEST = 'INSPECTION_VIEW_UPDATE_REQUEST';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const SET_INITIAL_FETCH = 'SET_INITIAL_FETCH';
export const SET_IS_LOADING_REPORT_DATA = 'SET_IS_LOADING_REPORT_DATA';
export const SET_REPORT_DATA_BY_TAB_ID = 'SET_REPORT_DATA_BY_TAB_ID';

// webhook init
export const WEBHOOK_VIEW_UPDATE = 'WEBHOOK_VIEW_UPDATE';
export const WEBHOOK_VIEW_SET_IS_LOADING_REQUESTS = 'WEBHOOK_VIEW_SET_IS_LOADING_REQUESTS';
export const WEBHOOK_VIEW_SET_IS_LOADING_DETAIL = 'WEBHOOK_VIEW_SET_IS_LOADING_DETAIL';
export const WEBHOOK_VIEW_SET_IS_REQUEST_SENT = 'WEBHOOK_VIEW_SET_IS_REQUEST_SENT';
//webhook end

// Http Calls
export const HTTP_CALL_VIEW_UPDATE = 'HTTP_CALL_VIEW_UPDATE';
export const HTTP_CALL_SET_VIEW_IS_LOADING_CALLS = 'HTTP_CALL_VIEW_IS_LOADING_CALLS';
export const HTTP_CALL_SET_IS_LOADING_DETAIL = 'HTTP_CALL_IS_LOADING_DETAIL';
export const HTTP_CALL_SET_IS_REQUEST_SENT = 'HTTP_CALL_SET_IS_REQUEST_SENT';

// state changes
export const STATE_CHANGES_VIEW_UPDATE = 'STATE_CHANGES_VIEW_UPDATE';
export const STATE_CHANGES_SET_IS_LOADING_DETAIL = 'STATE_CHANGES_IS_LOADING_DETAIL';
export const STATE_CHANGES_SET_IS_REQUEST_SENT = 'STATE_CHANGES_SET_IS_REQUEST_SENT';
export const STATE_CHANGES_SET_VIEW_IS_LOADING_STATES = 'STATE_CHANGES_SET_VIEW_IS_LOADING_STATES';

/**
 * Update current data context (= data for currently opened tab).
 */
export type UpdateCurrentDataContext = {
  type: typeof UPDATE_DATA_CONTEXT;
  payload: TabDataState;
};

/**
 * Does update of existing data.
 */
export type UpdateTabData = {
  type: typeof UPDATE_TAB_DATA;
  payload: TabDataState;
};

export type InitialiseTabData = {
  type: typeof INITIALISE_TAB_DATA;
  payload: TabDataState[];
};

export type AddTabData = {
  type: typeof ADD_TAB_DATA;
  payload: {
    tabData: TabDataState;
  };
};

/**
 * Update of the current inspection view state.
 */
export type InspectionViewUpdate = {
  type: typeof INSPECTION_VIEW_UPDATE;
  payload: InspectionDataState;
};

export type SetIsLoadingRequests = {
  type: typeof INSPECTION_VIEW_SET_IS_LOADING_REQUESTS;
  payload: boolean;
};

export type SetIsRequestSent = {
  type: typeof INSPECTION_VIEW_SET_IS_REQUEST_SENT;
  payload: boolean;
};

export type UpdateInspectionViewRequest = {
  type: typeof INSPECTION_VIEW_UPDATE_REQUEST;
  payload: TxiViewRequest;
};

export type SetIsLoadingDetail = {
  type: typeof INSPECTION_VIEW_SET_IS_LOADING_DETAIL;
  payload: boolean;
};

export type SetReportsData = {
  type: typeof SET_REPORT_DATA;
  payload: ReportsData | null;
};

export type SetInitialFetch = {
  type: typeof SET_INITIAL_FETCH;
  payload: boolean;
};

export type SetIsLoadingReportData = {
  type: typeof SET_IS_LOADING_REPORT_DATA;
  payload: boolean;
};

export type SetRequestsLoadedTimestamp = {
  type: typeof INSPECTION_VIEW_SET_REQUESTS_LOADED_TS;
  payload: number;
};

export type SetIsLoadingReportDataByTabId = {
  type: typeof SET_REPORT_DATA_BY_TAB_ID;
  payload: {
    tabId: string | number;
    reportsData: ReportsData | null;
  };
};

// State Changes
export type StateChangesViewUpdate = {
  type: typeof STATE_CHANGES_VIEW_UPDATE;
  payload: StateChangesState;
};

export type SetIsLoadingStateChanges = {
  type: typeof STATE_CHANGES_SET_VIEW_IS_LOADING_STATES;
  payload: boolean;
};

export type SetIsStateChangesRequestSent = {
  type: typeof STATE_CHANGES_SET_IS_REQUEST_SENT;
  payload: boolean;
};

export type SetIsLoadingStateChangesDetail = {
  type: typeof STATE_CHANGES_SET_IS_LOADING_DETAIL;
  payload: boolean;
};

// HTTP Calls
export type HttpCallViewUpdate = {
  type: typeof HTTP_CALL_VIEW_UPDATE;
  payload: HttpDataState;
};

export type SetIsLoadingHttpCalls = {
  type: typeof HTTP_CALL_SET_VIEW_IS_LOADING_CALLS;
  payload: boolean;
};

export type SetIsHttpCallRequestSent = {
  type: typeof HTTP_CALL_SET_IS_REQUEST_SENT;
  payload: boolean;
};

export type SetIsLoadingHttpCallsDetail = {
  type: typeof HTTP_CALL_SET_IS_LOADING_DETAIL;
  payload: boolean;
};

// webhook init
export type WebhookViewUpdate = {
  type: typeof WEBHOOK_VIEW_UPDATE;
  payload: HttpDataState;
};

export type SetIsLoadingWebhooks = {
  type: typeof WEBHOOK_VIEW_SET_IS_LOADING_REQUESTS;
  payload: boolean;
};

export type SetIsLoadingWebhooksDetail = {
  type: typeof WEBHOOK_VIEW_SET_IS_LOADING_DETAIL;
  payload: boolean;
};

export type SetIsWebhookRequestSent = {
  type: typeof WEBHOOK_VIEW_SET_IS_REQUEST_SENT;
  payload: boolean;
};
//webhook end

export type AnalyticsDataActionTypes =
  | UpdateCurrentDataContext
  | InspectionViewUpdate
  | UpdateTabData
  | AddTabData
  | InitialiseTabData
  | SetIsLoadingRequests
  | SetIsLoadingDetail
  | SetReportsData
  | UpdateInspectionViewRequest
  | SetRequestsLoadedTimestamp
  | SetInitialFetch
  | SetIsLoadingReportDataByTabId
  | SetIsLoadingReportData
  | SetIsRequestSent
  | WebhookViewUpdate
  | SetIsLoadingWebhooks
  | SetIsWebhookRequestSent
  | HttpCallViewUpdate
  | SetIsLoadingHttpCallsDetail
  | SetIsLoadingHttpCalls
  | SetIsHttpCallRequestSent
  | SetIsLoadingWebhooksDetail
  | StateChangesViewUpdate
  | SetIsLoadingStateChanges
  | SetIsStateChangesRequestSent
  | SetIsLoadingStateChangesDetail;
